import styles from './styles.module.css'

const QuestionList = ({ children }) => {
	return (
		<div className={styles.questionList}>
			{children}
		</div>
	)
}

export default QuestionList